import React from 'react';
import { useTranslation } from 'react-i18next';
import { AICallLogItem } from '../../types/aiCallLog';
import { legacyEpisodePath } from '../../utils/routes';

interface Props {
  item: Pick<AICallLogItem, 'episodeId' | 'episodeNo' | 'episodeName'>;
  stopPropagation?: boolean;
}

export default function AICallEpisodeLink({ item, stopPropagation }: Props) {
  const { t } = useTranslation('admin');
  const { episodeId, episodeNo, episodeName } = item;

  if (!episodeId) return <>—</>;

  const resolved = episodeName !== '' || episodeNo > 0;
  if (!resolved) {
    const title = t('aiCallLogs.episode.unavailableTitle', {
      id: episodeId,
      defaultValue: '分集信息不可用 · {{id}}',
    });
    return (
      <span style={{ color: 'var(--text-2)', cursor: 'default' }} title={title}>
        {episodeId.slice(0, 8)}
      </span>
    );
  }

  return (
    <a
      href={legacyEpisodePath(episodeId)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
    >
      {episodeName || `EP${episodeNo}`}
    </a>
  );
}
